import { callAPI } from "./core";

async function listSubscriptions(page, size, active, cancelled) {
  let params = {
    page: page,
    size: size
  };
  if (active != null) {
    params.active = active;
  } else if (cancelled != null) {
    params.cancelled = cancelled;
  }

  return await callAPI("/subscription", "GET", params, true);
}

async function getDowngradesGraph(startDate, endDate) {
  let params = {
    startDate: startDate.toISOString().split("T")[0],
    endDate: endDate.toISOString().split("T")[0]
  };

  return await callAPI(`/subscription/downgrades-graph`, "GET", params, true);
}

async function createSubscriptionCostOverride(
  facilityId,
  overrideAmount,
  startDate,
  expireDate
) {
  let params = {
    facilityId,
    overrideAmount,
    expireDate: expireDate.toISOString().split("T")[0],
    startDate: expireDate.toISOString().split("T")[0]
  };

  return await callAPI(`/subscription/override`, "POST", params, true);
}

async function updateSubscriptionCostOverrideExpireDate(
  overrideId,
  expireDate
) {
  let params = {
    expireDate: expireDate.toISOString().split("T")[0]
  };

  return await callAPI(
    `/subscription/override/${overrideId}`,
    "PATCH",
    params,
    true
  );
}

export {
  getDowngradesGraph,
  listSubscriptions,
  createSubscriptionCostOverride,
  updateSubscriptionCostOverrideExpireDate
};
